import { render, staticRenderFns } from "./product-gallery.vue?vue&type=template&id=5d2d6836&"
import script from "./product-gallery.vue?vue&type=script&lang=js&"
export * from "./product-gallery.vue?vue&type=script&lang=js&"
import style0 from "./product-gallery.vue?vue&type=style&index=0&id=5d2d6836&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports